import { modes } from '@/utils/types'
import style from './css'

const theme = {
  buttons: {
    color: '#eb0000'
  }
}

const lookupConfig = {
  source: 'did',
  country: 'SE',
  environment: 'test',
  identifyFields: 'email, zip',
  identifyProvider: 'bankId',
  didClientId: 'bambora-demo',
  containerWidth: '100%',
  checkUserDevice: false,
  theme: {
    ...theme
  }
}

const paymentIQCheckout = {
  label: 'Demo - PaymentIQ Checkout',
  display: 'page',
  config: {
    environment: 'test',
    merchantId: '100211999',
    amount: '1499',
    containerHeight: 'auto',
    showAccounts: 'inline',
    globalSubmit: true,
    showListHeaders: true,
    containerWidth: '650px',
    mode: modes.ECOMMERCE,
    locale: 'en_GB',
    font: 'custom,santander,santander',
    lookupConfig: {
      ...lookupConfig
    },
    theme: {
      ...theme
    }
  },
  style
}

export default {
  paymentIQCheckout
}
